import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Multiselect from 'react-widgets/lib/Multiselect';
import * as Yup from 'yup';
import { ApplicationState } from '~/store';
import {
  postTratamentoAtividadesRequest,
  resetPage,
  updateTratamentoAtividadesRequest,
} from '~/store/ducks/ManterAtividadesTratamentoDados/actions';
import getValidationErrors from '~/utils/getValidationErrors';
import { FormControlLGPD, MessageDPO, StyledTextField } from '../../styles';

interface PropsModal {
  row?: any;
  action: string;
}

const Modal: React.FC<PropsModal> = ({ row, action }) => {
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  const dispatch = useDispatch();

  const [formErr, setFormErr] = useState<any>({});

  const auth = useSelector<ApplicationState, any>(state => state.auth);

  const TratamentoAtividade = useSelector<ApplicationState, any>(
    state => state.ManterAtividadesTratamentoDados,
  );

  const [area, setArea] = useState<any>(0);

  const handleChangeArea = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: any;
    }>,
  ) => {
    setFormErr({
      ...formErr,
      area: false,
    });
    setArea(event.target.value);
  };

  const situacaoTypses = ['Ativado', 'Desativado'];

  const [situacao, setSituacao] = useState<number | null>(0);

  const handleChangeSituacao = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: any;
    }>,
  ) => {
    setFormErr({
      ...formErr,
      situacao: false,
    });
    setSituacao(event.target.value);
  };

  const ownershipTypes = ['Automático', 'Manual'];

  const [tipoConsentimento, setTipoConsentimento] = useState<number | null>(0);

  const handleChangeTipoConsentimento = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: any;
    }>,
  ) => {
    setFormErr({
      ...formErr,
      tipo_consentimento: false,
    });
    setTipoConsentimento(event.target.value);
  };

  const [message, setMessage] = useState<string | undefined>('');

  const handleChangeMessageDPO = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    setFormErr({
      ...formErr,
      message: false,
    });
    setMessage(event.target.value);
  };

  const [titulares, setTitulares] = React.useState<string[]>([]);

  interface FormContact {
    pessoa_responsavel: string;
    contato_responsavel: string;
  }

  const [form, setForm] = useState<FormContact>({
    pessoa_responsavel: '',
    contato_responsavel: '',
  });

  const handleChangeInput = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const target = event.target;
      const name = target.name;

      setFormErr({
        ...formErr,
        [name]: false,
      });
      setForm({
        ...form,
        [name]: target.value,
      });
    },
    [form, formErr],
  );

  const handleEditing = useCallback(
    (row: any) => {
      if (TratamentoAtividade.changeInsert === 'change') {
        setFormErr({});

        const titularesSemvirgula = row?.tipoDoTitularDeDados?.map((el: any) =>
          el.replace(',', '').trim(),
        );
        setTitulares(titularesSemvirgula);

        if (row.atividadeDeTratamentoDeDados) {
          setMessage(row.atividadeDeTratamentoDeDados);
        }

        if (typeof row.area === 'number') {
          setArea(row.area);
        } else {
          setArea(0);
        }

        setForm({
          pessoa_responsavel: !!row.pessoaResponsavel
            ? row.pessoaResponsavel
            : '',
          contato_responsavel: !!row.contatoDaPessoaResponsavel
            ? row.contatoDaPessoaResponsavel
            : '',
        });

        if (row.tipoDoConsentimento === 'Y') {
          setTipoConsentimento(1);
        }
        if (row.tipoDoConsentimento === 'N') {
          setTipoConsentimento(2);
        }
        if (row.situacao === 'Y') {
          setSituacao(1);
        }
        if (row.situacao === 'N') {
          setSituacao(2);
        }
      } else {
        setSituacao(0);
        setArea(0);
        setTipoConsentimento(0);
        setForm({ pessoa_responsavel: '', contato_responsavel: '' });
        setMessage('');
        setTitulares([]);
        setTimeout(() => {
          setExibir(false);
        }, 50);
        setTimeout(() => {
          setExibir(true);
        }, 100);
      }
    },
    [TratamentoAtividade.changeInsert],
  );

  useEffect(() => {
    if (row) {
      handleEditing(row);
    }
  }, [handleEditing, row, TratamentoAtividade.cleanModal, TratamentoAtividade]);

  const [exibir, setExibir] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setExibir(false);
    }, 50);
    setTimeout(() => {
      setExibir(true);
    }, 100);
  }, [row, TratamentoAtividade.cleanModal]);

  const updateAtividade = useCallback(async () => {
    try {
      const data = {
        situacao: situacao,
        area: area,
        message,
        pessoa_responsavel: form.pessoa_responsavel,
        contato_responsavel: form.contato_responsavel,
        titulares: titulares.length,
        tipo_consentimento: tipoConsentimento,
      };

      const schema = Yup.object().shape({
        message: Yup.string().required(
          'Atividade de tratamento de dados é obrigatorio!',
        ),
        pessoa_responsavel: Yup.string().required(
          'Pessoa responsável é obrigatorio!',
        ),
        contato_responsavel: Yup.string()
          .required('E-mail obrigatório')
          .email('Digite um e-mail válido'),
        situacao: Yup.string().test(
          'situacao',
          'situacao obrigatoria',
          value => {
            return value != '0' && value !== '' ? true : false;
          },
        ),
        area: Yup.string().test('area', 'area obrigatoria', value => {
          return value != '0' && value !== '' ? true : false;
        }),
        titulares: Yup.string().test(
          'titulares',
          'titulares obrigatoria',
          value => {
            return value != '0' ? true : false;
          },
        ),

        tipo_consentimento: Yup.string().test(
          'tipo_consentimento',
          'tipo_consentimento obrigatoria',
          value => {
            return value != '0' && value !== '' ? true : false;
          },
        ),
      });

      await schema.validate(data, { abortEarly: false });

      dispatch(
        updateTratamentoAtividadesRequest({
          area: area,
          atividadeDeTratamentoDeDados: message,
          codigoDaAtividade: row?.codigoDaAtividade,
          contatoDaPessoaResponsavel: form.contato_responsavel,
          empresa: row?.empresa,
          pessoaResponsavel: form.pessoa_responsavel,
          situacao,
          tipoConsentimento,
          tipoDoTitularDeDados: titulares,
        }),
      );

      closeButtonRef.current?.click();

      dispatch(resetPage(1));
    } catch (e) {
      if (e instanceof Yup.ValidationError) {
        const err = getValidationErrors(e);

        // console.log("err", err);

        toast.error('Necessário o preenchimento de todos os campos.');

        setFormErr(err);
      }
    }
  }, [
    area,
    dispatch,
    form.contato_responsavel,
    form.pessoa_responsavel,
    message,
    row,
    situacao,
    tipoConsentimento,
    titulares,
  ]);

  const postAtividade = useCallback(async () => {
    try {
      const data = {
        situacao: situacao,
        area: area,
        message,
        pessoa_responsavel: form.pessoa_responsavel,
        contato_responsavel: form.contato_responsavel,
        titulares: titulares.length,
        tipo_consentimento: tipoConsentimento,
      };

      const schema = Yup.object().shape({
        message: Yup.string().required(
          'Atividade de tratamento de dados é obrigatorio!',
        ),
        pessoa_responsavel: Yup.string().required(
          'Pessoa responsável é obrigatorio!',
        ),
        contato_responsavel: Yup.string()
          .required('E-mail obrigatório')
          .email('Digite um e-mail válido'),
        situacao: Yup.string().test(
          'situacao',
          'situacao obrigatoria',
          value => {
            return value != '0' && value !== '' ? true : false;
          },
        ),
        area: Yup.string().test('area', 'area obrigatoria', value => {
          return value != '0' && value !== '' ? true : false;
        }),
        titulares: Yup.string().test(
          'titulares',
          'titulares obrigatoria',
          value => {
            return value != '0' ? true : false;
          },
        ),

        tipo_consentimento: Yup.string().test(
          'tipo_consentimento',
          'tipo_consentimento obrigatoria',
          value => {
            return value != '0' && value !== '' ? true : false;
          },
        ),
      });

      await schema.validate(data, { abortEarly: false });

      dispatch(
        postTratamentoAtividadesRequest({
          area: area,
          atividadeDeTratamentoDeDados: message,
          contatoDaPessoaResponsavel: form.contato_responsavel,
          empresa: auth?.company?.country_company_id,
          pessoaResponsavel: form.pessoa_responsavel,
          situacao,
          tipoConsentimento,
          tipoDoTitularDeDados: titulares,
        }),
      );

      closeButtonRef.current?.click();

      dispatch(resetPage(1));
    } catch (e) {
      if (e instanceof Yup.ValidationError) {
        const err = getValidationErrors(e);

        // console.log("err", err);

        toast.error('Necessário o preenchimento de todos os campos.');

        setFormErr(err);
      }
    }

    // dispatch(resetPage(1));
  }, [
    area,
    auth,
    dispatch,
    form.contato_responsavel,
    form.pessoa_responsavel,
    message,
    situacao,
    tipoConsentimento,
    titulares,
  ]);

  return (
    <div
      className="modal-lgpd modal fade"
      id="exampleModal"
      tabIndex={-1}
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-lgpd" role="document">
        <div className="modal-content">
          <div className="modal-header" style={{ textAlign: 'center' }}>
            <h5
              className="modal-title"
              id="exampleModalLabel"
              style={{ fontSize: '1.8rem', fontWeight: 'bold' }}
            >
              {TratamentoAtividade.changeInsert === 'change'
                ? 'Editar atividade de tratamento de dados'
                : 'Incluir atividade de tratamento de dados'}
            </h5>
            <button
              type="button"
              className="close button-close-modal"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <FormControlLGPD
              variant="standard"
              ownershipTypeError={!!formErr?.situacao ? true : false}
            >
              <InputLabel htmlFor="ownershipType">Situação</InputLabel>
              <Select
                native
                value={situacao}
                onChange={handleChangeSituacao}
                label="Situação"
                inputProps={{
                  name: 'categoria',
                  id: 'categoria',
                }}
              >
                <option aria-label="ownershipType" value="" />
                {situacaoTypses.map((el, i) => {
                  if (!!el) {
                    return (
                      <option key={i} value={(i += 1)}>
                        {el}
                      </option>
                    );
                  }
                })}
              </Select>
            </FormControlLGPD>

            <FormControlLGPD
              variant="standard"
              ownershipTypeError={!!formErr?.area ? true : false}
            >
              <InputLabel htmlFor="ownershipType">Área</InputLabel>
              <Select
                native
                value={area}
                onChange={handleChangeArea}
                label="Área"
                inputProps={{
                  name: 'area',
                  id: 'area',
                }}
              >
                <option aria-label="ownershipType" value="" />
                {TratamentoAtividade.areas?.map((el: any) => {
                  if (!!el) {
                    return (
                      <option
                        key={el.company_area_id}
                        value={el.company_area_id}
                      >
                        {el.company_area_ds}
                      </option>
                    );
                  }
                })}
              </Select>
            </FormControlLGPD>

            <p className={!!formErr?.message ? 'erro-c-red' : ''}>
              Atividade de tratamento de dados
            </p>
            <MessageDPO
              messageError={!!formErr.message ? true : false}
              name="message"
              id="message"
              value={message}
              onChange={handleChangeMessageDPO}
              rows={10}
              className="message-DPO"
            />
            <StyledTextField
              identificationKeyError={
                !!formErr?.pessoa_responsavel ? true : false
              }
              id="pessoa_responsavel"
              label="Pessoa responsável"
              name="pessoa_responsavel"
              value={form.pessoa_responsavel}
              onChange={handleChangeInput}
              variant="standard"
              className="TextField-lgpd-table"
            />
            <StyledTextField
              identificationKeyError={
                !!formErr?.contato_responsavel ? true : false
              }
              id="contato_responsavel"
              label="Contato da pessoa responsável (E-mail)"
              name="contato_responsavel"
              value={form.contato_responsavel}
              onChange={handleChangeInput}
              variant="standard"
              className="TextField-lgpd-table"
            />

            <p
              className={`tito_de_titular_de_dados ${
                !!formErr?.titulares ? 'tito_de_titular_de_dados-error' : ''
              }`}
            >
              Tipo de titular de dados
            </p>

            {exibir && TratamentoAtividade.loading && (
              <Multiselect
                containerClassName={`Multiselect-lgpd ${
                  !!formErr?.titulares ? 'Multiselect-lgpd-error' : ''
                }`}
                id="Multiselect"
                data={TratamentoAtividade.data.categorias.map(
                  (el: any) => el.data_holder_cat_name,
                )}
                onChange={(dataItems, metadata) => {
                  if (metadata.action === 'remove') {
                    const index = titulares.indexOf(metadata.dataItem);

                    const tmp = titulares;

                    if (!tmp.includes(metadata.dataItem)) {
                      tmp.splice(index, 0, metadata.dataItem);

                      setTitulares(tmp);
                    } else {
                      tmp.splice(index, 1);

                      setTitulares(tmp);
                    }
                  }
                  if (metadata.action === 'insert') {
                    const index = titulares.indexOf(metadata.dataItem);

                    const tmp = titulares;

                    if (!tmp.includes(metadata.dataItem)) {
                      tmp.splice(index, 0, metadata.dataItem);

                      setTitulares(tmp);
                      setFormErr({
                        ...formErr,
                        titulares: false,
                      });
                    }
                  }
                }}
                defaultValue={
                  row?.tipoDoTitularDeDados &&
                  TratamentoAtividade.changeInsert === 'change'
                    ? row.tipoDoTitularDeDados.map((el: any) =>
                        el.replace(',', '').trim(),
                      )
                    : []
                }
              />
            )}

            <FormControlLGPD
              className="auto-man"
              variant="standard"
              ownershipTypeError={!!formErr?.tipo_consentimento ? true : false}
            >
              <InputLabel htmlFor="ownershipType">
                Tipo de consentimento
              </InputLabel>
              <Select
                native
                value={tipoConsentimento}
                onChange={handleChangeTipoConsentimento}
                label="Categoria"
                inputProps={{
                  name: 'ownershipType',
                  id: 'ownershipType',
                }}
              >
                <option aria-label="ownershipType" value="" />
                {ownershipTypes.map((el, i) => {
                  if (!!el) {
                    return (
                      <option key={i} value={(i += 1)}>
                        {el}
                      </option>
                    );
                  }
                })}
              </Select>
            </FormControlLGPD>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
              ref={closeButtonRef}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                if (TratamentoAtividade.changeInsert === 'change') {
                  updateAtividade();
                } else {
                  postAtividade();
                }
              }}
            >
              {TratamentoAtividade.changeInsert === 'change'
                ? 'Salvar alteração'
                : 'Incluir'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
